/**
 * Hashes an email address using SHA-256
 * This is the recommended hashing method for TikTok Pixel
 * @param {string} email - The email address to hash
 * @returns {Promise<string>} - The hashed email in lowercase
 */
export const hashEmail = async email => {
  if (!email) return null;

  const normalizedEmail = email.trim().toLowerCase();
  const encoder = new TextEncoder();
  const data = encoder.encode(normalizedEmail);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex.toLowerCase();
};
